import React from 'react'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import TextLink from 'components/Luxkit/TextLink'
import useToggle from 'hooks/useToggle'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { rem } from 'polished'
import LineClockDollarIcon from 'components/Luxkit/Icons/line/LineClockDollarIcon'
import InlineGroup from 'components/Common/InlineGroup'
import { getDepositAmountPercentage } from 'lib/depositsUtils'
import { mediaQueryUp } from 'components/utils/breakpoint'
import FormatCurrency from 'components/Common/FormatCurrency'
import PayInInstalmentsMoreInfoModal from 'components/Common/PayInInstalmentsInfo/PayInInstalmentsMoreInfoModal'

const Root = styled(Pane)`
  text-align: center;
`

const StyledInlineGroup = styled(InlineGroup)`
  margin-bottom: ${rem(8)};
  display: block;
`

const StyledLink = styled(TextLink)`
  margin-top: ${rem(8)};
`

const StyledBodyText = styled(BodyText)`
  ${mediaQueryUp.desktop} {
    margin-left: ${rem(4)};
  }
`

const StyledPaneBody = styled(PaneBody)`
  padding: ${rem(16)} ${rem(0)};

  ${mediaQueryUp.desktop} {
    padding: ${rem(16)} ${rem(12)};
  }
`

interface Props {
  offer: App.Offer;
  currency: string;
  instalmentWeeklyAmount: number;
  defaultDepositAmountPercentage: number;
}

function OfferFlexiblePaymentsInfo(props: Props) {
  const {
    offer,
    currency,
    instalmentWeeklyAmount,
    defaultDepositAmountPercentage,
  } = props

  const [showModal, _, openModal, onCloseModal] = useToggle(false)
  const depositPercentage = getDepositAmountPercentage(offer, defaultDepositAmountPercentage)

  return (<>
    <PayInInstalmentsMoreInfoModal
      isPolicyOpen={showModal}
      closePolicy={onCloseModal}
      depositPercentage={depositPercentage}/>
    <Root>
      <StyledPaneBody>
        <StyledInlineGroup>
          <LineClockDollarIcon size="L" />
          <StyledBodyText variant="large" weight="bold">
            Secure select packages with a {depositPercentage}% deposit
          </StyledBodyText>
        </StyledInlineGroup>
        <BodyText variant="medium">
          Enjoy the freedom to pay the rest later with a payment plan that suits you.
          {!!instalmentWeeklyAmount &&
            <>
              {' '}Starting from <FormatCurrency currency={currency} value={instalmentWeeklyAmount} />/week.
            </>
          }
        </BodyText>
        <StyledLink onClick={openModal}>
          Learn more
        </StyledLink>
      </StyledPaneBody>
    </Root>
  </>

  )
}

export default OfferFlexiblePaymentsInfo
